export default __webpack_public_path__ + "static/media/ic_samoa.f99857bc.svg";